<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    

    <v-stepper 
        v-model="stage" 
        vertical
    >
         <v-stepper-step 
            step="1" 
            :complete="stage > 1"
        >
            Choose Domain Name
        </v-stepper-step>

        <v-stepper-content step="1">
            <v-text-field
                label="Domain Name"
                v-model="domain"
                autofocus
                :hint="domainHint()"
                v-on:keyup.native.enter="onEnterInDomainField"
                autocomplete="off"
            />

            <v-btn 
                text color="primary"
                class="my_button"
                v-on:click="stage = 2"
                :disabled="!isValidDomain()"
            >
                Continue
            </v-btn>

            <v-btn 
                v-on:click="onCancel"
                class="my_button"
                text
            >
                Cancel
            </v-btn>
            
            
        </v-stepper-content>

        <v-stepper-step 
            step="2" 
            :complete="stage > 2"
        >
            Choose Domain Ownership Verification Method
        </v-stepper-step>
           
        <v-stepper-content step="2">
            <v-radio-group 
                v-model="method" 
                :mandatory="true"
                
            >
                <v-radio 
                    label="Add a META tag or file to your website" 
                    value="http"
                >
                </v-radio>
                <v-radio 
                    label="Add a TXT record to your DNS" 
                    value="txt"
                >
                </v-radio>
                <v-radio 
                    label="Add a CNAME record to your DNS" 
                    value="cname"
                >
                </v-radio>
                <v-radio 
                    label="Skip verification (using your admin privledges)" 
                    value="admin"
                    v-if="is_admin"
                >
                </v-radio>
            </v-radio-group>

            <v-btn 
                text color="primary"
                class="my_button"
                v-on:click="stage = 3"
            >
                Continue
            </v-btn>

            <v-btn 
                v-on:click="onCancel"
                class="my_button"
                text
            >
                Cancel
            </v-btn>

             <v-btn 
                v-on:click="stage = 1"
                class="my_button"
                text
            >
                Go Back
            </v-btn>
        </v-stepper-content>

        

        <v-stepper-step 
            step="3" 
            v-show="stage < 2"
        >
            Verify Ownership
        </v-stepper-step>

        <v-stepper-step 
            step="3" 
            v-show="stage >= 2 && method == 'txt'"
        >
            Verify Ownership Using TXT Record
        </v-stepper-step>

        <v-stepper-step 
            step="3" 
            v-show="stage >= 2 && method == 'cname'"
        >
            Verify Ownership Using CNAME Record
        </v-stepper-step>

        <v-stepper-step 
            step="3" 
            v-show="stage >= 2 && method == 'http'"
        >
            Verify Ownership Using META Tag or File
        </v-stepper-step>

        <v-stepper-step 
            step="3" 
            v-show="stage >= 2 && method == 'admin'"
        >
            Verify Ownership Using Admin Privledges
        </v-stepper-step>


        <v-stepper-content 
            step="3"
            v-show="method == 'http'"
        >
            
            Add the following meta tag to the index (home) page of your website:

            <m-code-block>&lt;meta name="redchirp-organization-id" content="{{organization_id}}"/&gt;</m-code-block>
            
            Alternatively, you can upload with the following contents:

            <m-code-block>{{organization_id}}</m-code-block>

            to one of the following URL(s)

            <ul>
                <li><span class="code">https://www.{{domain}}/redchirpverify.txt</span></li>
                <li><span class="code">https://www.{{domain}}/redchirpverify.txt</span></li>
            </ul>

            <v-btn 
                color="primary"
                v-on:click="onAddDomain()"
                class="my_button"
            >
                Add Domain Name
            </v-btn>

            <v-btn 
                v-on:click="stage = 2"
                class="my_button"
            >
                Go Back
            </v-btn>

            <v-btn 
                v-on:click="onCancel"
                class="my_button"
            >
                Cancel
            </v-btn>
            

        </v-stepper-content>

        <v-stepper-content 
            step="3"
            v-show="method == 'txt'"
        >
            
            Create a TXT record with the host <span class="code">@</span> in zone (domain) <span class="code">{{domain}}.</span>

            <m-code-block>rc-organization-id={{organization_id}}</m-code-block>

            The zone file syntax would be:

            <m-code-block>@ 3600 IN TXT "rc-organization-id={{organization_id}}"</m-code-block>

            <v-btn 
                color="primary"
                v-on:click="onAddDomain()"
                class="my_button"
            >
                Add Domain Name
            </v-btn>

            <v-btn 
                v-on:click="stage = 2"
                class="my_button"
            >
                Go Back
            </v-btn>

            <v-btn 
                v-on:click="onCancel"
                class="my_button"
            >
                Cancel
            </v-btn>
            

        </v-stepper-content>

        <v-stepper-content 
            step="3"
            v-show="method == 'cname'"
        >
            
            Create a CNAME record with the host 

            <m-code-block>redchirp-verification</m-code-block>
            
            in zone (domain) <span class="code">{{domain}}.</span> with a target of:

            <m-code-block>rcv-{{organization_id}}.redchirp.com.</m-code-block>

            The zone file syntax would be:

            <m-code-block>redchirp-verification.{{domain}}.         IN      CNAME   rcv-{{organization_id}}.redchirp.com.</m-code-block>

            <v-btn 
                color="primary"
                v-on:click="onAddDomain()"
                class="my_button"
            >
                Add Domain Name
            </v-btn>

            <v-btn 
                v-on:click="stage = 2"
                class="my_button"
            >
                Go Back
            </v-btn>

            <v-btn 
                v-on:click="onCancel"
                class="my_button"
            >
                Cancel
            </v-btn>
            

        </v-stepper-content>

        <v-stepper-content 
            step="3"
            v-show="method == 'admin'"
        >
            
            This method uses your system administration privledges to bypass verification.  No checks will be performed.  <strong>Please check your work carefully!</strong>
            <br/>
            <br/>

            <v-btn 
                color="primary"
                v-on:click="onAddDomain()"
                class="my_button"
            >
                Add Domain Name
            </v-btn>

            <v-btn 
                v-on:click="stage = 2"
                class="my_button"
            >
                Go Back
            </v-btn>

            <v-btn 
                v-on:click="onCancel"
                class="my_button"
            >
                Cancel
            </v-btn>
            

        </v-stepper-content>
        

    </v-stepper>
	
    </v-card>

    <v-overlay
    
        opacity="0.3"
        :value="show_spinner"
        z-index="10"
    >
        <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
    ></v-progress-circular>
    </v-overlay>

</v-dialog>
</template>

<script>

const Validate = require('@/js/validate.js');
var Preconditions = require('@/js/Preconditions.js'); 

export default {

    data() {
        return {
            dialog: false,
            domain: '',
            method: 'txt',
            stage: 1,
            is_admin: false,
            organization_id: '',
            show_spinner: false,
        }
    },

    methods: {

        showDialog(is_admin, organization_id) 
        {
            this.dialog = true;
            this.domain = '';
            this.method = '';
            this.stage = 1;
            this.is_admin = this.$rc.isAuthActorSystemAdmin();
            this.organization_id = organization_id;

            
            this.show_spinner = false;
        },

        onCancel()
        {
            this.dialog = false;
            
        },

        isValidDomain()
        {
            return Preconditions.isHostName(this.domain);
        },

        domainHint()
        {
            if ( this.domain.trim().toLowerCase().startsWith('www.') )
                return "Domain names should not include the www";

            return null;
        },

        onEnterInDomainField()
        {
            if ( this.isValidDomain() )
                this.stage = 2;
        },

        onAddDomain()
        {
            this.show_spinner = true;
            this.$forceUpdate();

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'POST: /api/v1/organizations/domains/verify-domain',
            
                'params' : {
                    'organization_id' : this.organization_id,
                    'method' : this.method,
                    'domain' : this.domain,
                },
            
                'on_success': (data) => {
                        alert('The domain '+this.domain+' has been added to your organization');
                        this.show_spinner = false;
                        this.dialog = false;
                        this.$emit('domain-added');
                    },
            
                'on_error': () => {
                    this.show_spinner = false;
                    alert('Unable to verify domain name ownership.  Check your settings and try again.');
                },
            });
        }
    },
}
</script>

<style lang="scss" scoped>
.my_button
{
    margin-right: 8px;
    margin-top: 5px;
    margin-bottom: 5px;
}

span.code {
    font-family: monospace;
    font-weight: 700;
}
</style>